<template>
    <div class="d-flex flex-column pl-md-4 pl-0 mb-md-3 mt-md-0 mt-4 flex-1-1-0">
        <template v-if="travelMoneyAmount || geography">
            <div class="d-block justify-space-between mb-6">
                <div v-if="travelMoneyAmount" class="d-flex align-end">
                    <span class="text-medium-emphasis flex-1-1-0 text-size-md"> {{ t('orderReceipt.travelMoney') }} </span>
                    <span
                        data-id="travelMoneyAmount"
                        class="text-subtitle-1 font-weight-bold text-secondary-dark text-heading line-height-lg"
                    >
                        {{ formatKr(travelMoneyAmount) }}
                    </span>
                </div>
                <div v-if="geography" class="d-flex align-end mt-2">
                    <span class="text-medium-emphasis flex-1-1-0 text-size-md"> {{ t('travelCard.fixedRoute') }} </span>
                    <travel-card-geo :geography="geography" class-name="text-body-2 text-secondary-dark text-size-lg font-weight-bold" />
                </div>
            </div>
            <div class="text-caption text-medium-emphasis text-size-xs line-height-mg">
                <p class="mb-3">
                    {{ t('travelCard.ticketUsageDescription') }}
                </p>
                <p class="d-block">
                    {{ t('travelCard.travelMoneyUsageDescription') }}
                </p>
            </div>
        </template>
        <template v-if="isCardEmpty && !travelMoneyAmount">
            {{ t('travelCard.emptyCardDescription') }}
        </template>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import TravelCardGeo from '../card/TravelCardGeo.vue';
import { ITravelCardTopUpStatus } from '../../types';
import { formatKr } from '@/helpers';
import '../../styles/main.scss';

defineProps<ITravelCardTopUpStatus>();
const { t } = useI18n();
</script>
